import axios from 'axios';
import Resource from './Resource'
import { compare } from '@/utils/util'

export default class Subject extends Resource {
  static ENDPOINT = '/api/summary'

  static async getByStudent (training, student) {
    const res = await axios.get(`${this.ENDPOINT}/getbystudent`, {
      params: { training, student }
    });
    return res.data
  }

  static async getBySubject (training, subject, lecture, code) {
    console.log('getBySubject', training, subject, lecture, code)
    const res = await axios.get(`${this.ENDPOINT}/getbysubject`, {
      params: { training, subject, lecture, code }
    });
    return res.data
  }

  static async getTotalSummary (training) {
    const res = await axios.get(`${this.ENDPOINT}/gettotalsummary`, {
      params: { training }
    });
    return res.data
  }

  static async getSchedule (query) {
    const res = await axios.get(`${this.ENDPOINT}/getschedule`, {
      params: query
    });
    return res.data
  }

  static async getTestSchedule (query) {
    const res = await axios.get(`${this.ENDPOINT}/gettestschedule`, {
      params: query
    });
    return res.data
  }
}
